import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Logo from "../../assets/LOGO_bg.png";
import Avatar from "../../assets/avatar.jpg";
import { connect, useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { authLogout } from "../../services/auth/actions";
import { AUTH_LOGIN } from "../../services/auth/actionTypes";
import "./style.scss";
import Loader from "../Loader";

const Navbar = ({ authLogout, user }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { app } = useSelector(({ filtersState }) => ({
    app: filtersState.app,
  }));

  useEffect(() => {
    if (app.apiKey === null) history.push("/apps");
    // eslint-disable-next-line
  }, [app]);
  useEffect(() => {
    if (!user) {
      let local = JSON.parse(localStorage.getItem("user"));
      if (local) {
        dispatch({ type: AUTH_LOGIN, payload: local });
      } else {
        localStorage.clear();
        authLogout();
        history.push("/login");
      }
    }
  }, [authLogout, user, history, dispatch]);
  const Logout = () => {
    let tokenObj = JSON.parse(localStorage.getItem("user"));
    let email = localStorage.getItem("email");
    setIsLoading(true);
    axios({
      url: "https://obscure-dawn-59750.herokuapp.com/user/logout",
      method: "POST",
      data: {
        token: tokenObj.accessToken,
        email,
      },
    })
      .then(() => {
        localStorage.clear();
        authLogout();
        setIsLoading(false);
        setTimeout(() => {
          history.push("/login");
        }, 100);
      })
      .catch(() => setIsLoading(false));
  };
  return (
    <div className="navbar_container">
      {isLoading && <Loader />}
      <Link to="/apps">
        <img src={Logo} alt="Bevoice" />
      </Link>
      <div className="links">
        <div className="user-info app-name-actions" onClick={Logout}>
          Logout
        </div>
        <div className="user-info">
          <img src={Avatar} alt="avatar" />{" "}
          <span>
            Welcome {user && user.userDetails ? user.userDetails.Name : ""}!
          </span>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  user: state.authState.user,
});

export default connect(mapStateToProps, { authLogout })(Navbar);
